import React from "react";

import styles from "./FilterSummary.less";

export type ZoneFilterValue = "all" | "service" | "sales";

export const ZONE_FILTER_DEALER_ID = 2042778208;

const ZONE_FILTERS_CONFIG: { name: ZoneFilterValue; label: string }[] = [
  { name: "all", label: "Все" },
  { name: "service", label: "Сервис" },
  { name: "sales", label: "Продажа" },
];

interface ZoneFilterIProps {
  zone: ZoneFilterValue;
  applyZoneFilter: (newZone: ZoneFilterValue) => void;
}

const ZoneFilter = ({ applyZoneFilter, zone }: ZoneFilterIProps) => {
  return (
    <div className={styles.zoneFilter}>
      {ZONE_FILTERS_CONFIG.map((filter) => (
        <span
          key={filter.name}
          onClick={() => applyZoneFilter(filter.name)}
          className={
            zone === filter.name
              ? styles.activeFastFilter
              : styles.defaultFastFilter
          }
        >
          {filter.label}
        </span>
      ))}
    </div>
  );
};

export default ZoneFilter;
